import commonUtil from '../../common-util';
import { QUES_TYPE_NAMES, QUES_LEVEL_NAMES } from './const';
import { getGuid, htmlEncode, convertASCIIForNum } from './utils';
import { domainBaseUrl } from '../../common-util/domain';
const i18n = commonUtil.i18n;
const bracketKey = ['[', ']'];
// const bracketKey = ['【', '】'];

/**
 * AI的问答ID管理，处理页面关闭自动销毁
 */
export const AIAskIdManager = function() {
  this.AskIdHandler = new commonUtil.CommonAskIdHandler();

  this.get = () => {
    return this.AskIdHandler.getAskId();
  };

  this.destroy = () => {
    this.AskIdHandler.destoryReleaseAsset();
  };
};

/**
 * AI对话的websocket链接
 * @returns {Object} ws发送/接收消息处理
 */
export const AIWsClient = function() {
  this.wsInstance = null; // websocket实例
  this.wsDealInfo = null; // 单次发送消息相关标识

  /**
   * 发送AI消息
   * @param {Object} postData 消息体
   * @param {Object} config { onMsg 每次收到消息回调, onEnd 消息接收完毕回调, onError 异常回调, originSpeed 是否采用接口原始吐字速度（默认会做平滑处理，原始接口一大段一大段吐） }
   */
  this.sendWSMsg = function(postData, {onMsg, onEnd, onError, originSpeed}) {
    const wsinfoMsg = {
      type: 'openai',
      jwt: window.getLocalStorage('token'),
      body: postData
    };

    this.wsDealInfo = {
      askIndex: new Date().getTime(),
      answered: false,
      txtProcessing: [], // 待输出的文字
      txtProcessingIndex: 0,
      aborted: false, // 是否已经终止
      processingItv: null, // 输出定时器
      originSpeed: originSpeed,
      end: false // 是否接口响应完成
    };

    // 处理消息的方法
    const processText = (lastMsg) => {
      try {
        if (lastMsg) {
          this.wsDealInfo.txtProcessingIndex = this.wsDealInfo.txtProcessing.length - 1;
        }

        const cmsg = this.wsDealInfo.txtProcessing[this.wsDealInfo.txtProcessingIndex];
        if (cmsg) {
          let aiMessage = '';
          try {
            aiMessage = JSON.parse(cmsg);
            aiMessage =
                (aiMessage.result && JSON.parse(aiMessage.result)) ||
                aiMessage;
          } catch (error) {
            this.wsDealInfo.txtProcessingIndex++;
            return;
          }

          if (aiMessage && aiMessage.error) {
            onError && onError({ name: aiMessage.error.type });
            this.abort();
            return;
          }

          const msgDealed =
              aiMessage && aiMessage.choices && aiMessage.choices[0];
          if (msgDealed.finish_reason === 'stop') {
            this.wsDealInfo.end = true;
          }
          const info = msgDealed.delta && msgDealed.delta.content;

          this.wsDealInfo.answered = true;
          info && onMsg && onMsg(info);
          this.wsDealInfo.txtProcessingIndex++;
        }

        if (
          this.wsDealInfo.end &&
          (this.wsDealInfo.txtProcessingIndex >= this.wsDealInfo.txtProcessing.length)
        ) {
          onEnd();
          this.abort();
        }
      } catch (error) {
        onError();
        this.abort();
      }
    };

    if (!this.wsInstance) {
      this.createWebsocket(message => {
        if (this.wsDealInfo.aborted) return;

        this.wsDealInfo.txtProcessing.push(message);

        if (this.wsDealInfo.originSpeed) {
          processText(true);
        } else if (!this.wsDealInfo.processingItv) {
          this.wsDealInfo.processingItv = setInterval(() => {
            processText();
          }, 20); // 吐字间隔
        }
      }, wsinfoMsg);
    } else {
      this.wsInstance.sendHandle(wsinfoMsg);
    }

    // 处理60s没返回 判断超时
    const oldAskIndex = this.wsDealInfo.askIndex;
    this.wsDealInfo.errorSt = setTimeout(() => {
      if (
        !this.wsDealInfo.answered &&
          oldAskIndex === this.wsDealInfo.askIndex &&
          this.asking
      ) {
        onError && onError({ name: 'ws-timeout' });

        this.destroy();
        this.abort();
      }
    }, 60 * 1000);
  };
  // 创建websocket链接
  this.createWebsocket = function(onMsg, data) {
    this.wsInstance = new commonUtil.CreateWebSocket(
      `${domainBaseUrl('wsBaseUrl')}websocketsvc`,
      onMsg,
      'ote-ai—ques'
    );
    this.wsInstance.connect(data);
  };
  // 销毁websocket链接
  this.destroy = function() {
    try {
      this.wsInstance && this.wsInstance.closeMyself();
      this.wsInstance = null;
    } catch (error) {}
  };
  // 终止/完成消息发送
  this.abort = function() {
    if (this.wsDealInfo.aborted) return;

    this.wsDealInfo.aborted = true;
    this.wsDealInfo.processingItv &&
            clearInterval(this.wsDealInfo.processingItv);
    this.wsDealInfo.errorSt && clearTimeout(this.wsDealInfo.errorSt);
    // TODO ws能否关闭服务端的处理？
  };
};

/**
 * 循环接口调用
 * @param {*} postData 请求数据
 * @param {*} configs {onMsg, onEnd, onError, onStatus}
 * @param {*} apis {callApi, checkApi, stopApi, resultApi}
 * @param {*} step 心跳间隔 秒
 * @returns { abort, complete }
 */
export const loopApiCaller = function(postData, configs, apis, step = 5, timeout = 1800) {
  const { callApi, checkApi, stopApi, resultApi } = apis;
  const { onMsg, onEnd, onError, onStatus } = configs;
  let processingItv = null; // 输出定时器
  let aborted = false; // 是否已经终止
  let taskId = '';
  const callInfo = {
    usedTime: 0
  };

  // 终止/完成消息发送
  const abort = function() {
    if (aborted) return;

    aborted = true;
    processingItv && clearInterval(processingItv);
    taskId && stopApi && stopApi(taskId);
  };
  const checkStatus = function() {
    checkApi && checkApi(taskId).then((resStatus) => {
      if (aborted) return;

      onStatus && onStatus(resStatus, taskId);
    }).catch((err) => {
      if (aborted) return;
      onError && onError(err);
    });
  };
  // 完成任务获取结果数据
  const complete = function(res) {
    console.log('AI处理耗时：', callInfo.usedTime, '秒');
    processingItv && clearInterval(processingItv);
    if (aborted) return;

    if (res) {
      aborted = true;
      onEnd && onEnd(res);
      return;
    }

    resultApi(taskId).then((res) => {
      if (aborted) return;

      aborted = true;
      onEnd && onEnd(res);
    }).catch((err) => {
      if (aborted) return;
      onError && onError(err);
    });
  };

  // 获取任务的时时结果数据
  const getMsg = function(res) {
    if (res) {
      onMsg && onMsg(res);
      return;
    }

    resultApi(taskId).then((res) => {
      if (aborted) return;

      onMsg && onMsg(res);
    }).catch((err) => {
      if (aborted) return;
      onError && onError(err);
    });
  };

  // 发起任务
  callApi && callApi(postData).then((res) => {
    if (aborted) return;

    taskId = res.targetId;

    // 检查任务状态
    checkStatus();
    processingItv = setInterval(() => {
      if (callInfo.usedTime >= timeout) {
        onError && onError();
        return;
      }

      callInfo.usedTime++;
      if (callInfo.usedTime % step < 1) {
        checkStatus();
      }
    }, 1000);
  }).catch((err) => {
    if (aborted) return;
    onError && onError(err);
  });

  return {
    checkStatus,
    abort,
    getMsg,
    complete,
    callInfo
  };
};

let promptKeywords = null;
/**
 * 获取出题的关键词，主要使多语言时，AI出的和系统解析的保持一致
 * @returns
 */
export const getAIQuesPromptKeywords = function() {
  if (promptKeywords) {
    return promptKeywords;
  }
  // '[单选题]', '[多选题]', '[判断题]', '[填空题]', '[问答题]'
  const QUES_TYPE = QUES_TYPE_NAMES.filter((_, index) => index < 5).map(tn => bracketKey[0] + i18n.t(tn) + bracketKey[1]);
  // 判断题答案 [Y][N]
  const ANSWER_TYPE = [bracketKey[0] + 'N' + bracketKey[1], bracketKey[0] + 'Y' + bracketKey[1]];
  // '解析'
  const EXPLAIN_TEXT_KEY = i18n.t('pc_biz_ote_lbl_quesanalyze');
  // '答案'
  const ANSWER_TEXT_KEY = i18n.t('pc_biz_ote_lbl_itemanswer');
  // 难易度类型
  const LEVEL_TYPE = QUES_LEVEL_NAMES.values.map((lv, index) => bracketKey[0] + i18n.t(QUES_LEVEL_NAMES[index]) + bracketKey[1]);
  // 难易度类型 按照难度排序，数组下标与实际难度不一致
  const LEVEL_TYPE_SORTED = QUES_LEVEL_NAMES.values.map(lv => bracketKey[0] + i18n.t(QUES_LEVEL_NAMES[lv]) + bracketKey[1]);

  promptKeywords = {
    quesType: QUES_TYPE,
    explain: EXPLAIN_TEXT_KEY,
    answer: ANSWER_TEXT_KEY,
    judgeAnswer: ANSWER_TYPE,
    levelType: LEVEL_TYPE,
    levelTypeSorted: LEVEL_TYPE_SORTED
  };
  return promptKeywords;
};

/**
 * 单个题型的输出示例prompt
 * @param {Number} createQuesType 出题类型  0-单选题 1-多选题 2-判断题 3-填空题 4-问答题
 * @returns
 */
export const getAIQuesTypePrompt = function(createQuesType = 0) {
  const keywords = getAIQuesPromptKeywords();
  const QUES_TYPE = keywords.quesType;
  const ANSWER_TYPE = keywords.judgeAnswer;
  const EXPLAIN_TEXT_KEY = keywords.explain;
  const ANSWER_TEXT_KEY = keywords.answer;
  const LEVEL_TYPE = keywords.levelType;
  const LEVEL_TYPE_SORTED = keywords.levelTypeSorted;

  const currentQuesType = QUES_TYPE[createQuesType];
  // 题目格式示例
  const caseAll = [
    // 单选题示例
    `
##输出的格式要求
"${currentQuesType}"标识试题的题型；
"${LEVEL_TYPE[0]}”标识难易度；
"${ANSWER_TEXT_KEY}"标识试题的答案；
"${EXPLAIN_TEXT_KEY}"标识试题的解析；
每道试题的第一行是试题的题干；
题型写在试题题干的最前面，难易度跟在题型后，格式示例：${currentQuesType}${LEVEL_TYPE[0]}下面哪一项不属于面向对象的特性；
答案写在选项的下面一行，解析写在答案的下面一行；
每道试题的难度仅有：${LEVEL_TYPE_SORTED.join('、')} ${LEVEL_TYPE_SORTED.length === 3 ? '三' : '五'}种格式可选；
请保证每道题均来自于知识；
请不要输出分析过程内容，直接按照格式标准输出内容；
解析内容不要包含参考文档的名称，解析的文字描述为试题的知识点内容;

##输出的参考格式示例
${currentQuesType}${LEVEL_TYPE[0]}下面哪一项不属于面向对象的特性。
A、封装性
B、原子性
C、继承性
D、多态性
${ANSWER_TEXT_KEY}: B
${EXPLAIN_TEXT_KEY}: 原子性不是面对对象的特性`,

    // 多选题示例
    `
##输出的格式要求
"${LEVEL_TYPE[0]}"标识试题的难易度；
"${ANSWER_TEXT_KEY}"标识试题的答案；
"${EXPLAIN_TEXT_KEY}"标识试题的解析；
"${currentQuesType}"标识试题的题型；
每道试题的第一行是试题的题干；
题型写在试题题干的最前面，难易度跟在题型后面；
答案写在最后一个选项的下面一行，解析写在答案的下面一行；
每道试题的答案有2个或者多个选项，多个答案之间，用空格来区分；
每道试题的难度仅有：${LEVEL_TYPE_SORTED.join('、')} ${LEVEL_TYPE_SORTED.length === 3 ? '三' : '五'}种格式可选；
不要输出JSON格式；

##输出的参考格式示例
${currentQuesType}${LEVEL_TYPE[0]}下面哪些项属于面向对象的特性。
A、封装性
B、原子性
C、继承性
D、多态性
${ANSWER_TEXT_KEY}: A C D
${EXPLAIN_TEXT_KEY}: 面向对象特性有封装性、继承性、多态性。`,
    // 判断题示例
    `
##输出的格式要求
"${LEVEL_TYPE[0]}"标识试题的难易度；
"${ANSWER_TEXT_KEY}"标识试题的答案；
"${EXPLAIN_TEXT_KEY}"标识试题的解析；
"${currentQuesType}"标识试题的题型；
"${ANSWER_TYPE[1]}"标识试题的答案内容；
每道试题的第一行是试题的题干；
题型写在试题题干的最前面，难易度跟在题型后面；
题型、难易度、题干在同一行上面；
答案写在题干的下面一行，解析写在答案的下面一行；
每道试题的答案仅有1个：如果判对，用${ANSWER_TYPE[1]}标识；如果判错，用${ANSWER_TYPE[0]}标识；
每道试题的难度仅有：${LEVEL_TYPE_SORTED.join('、')} ${LEVEL_TYPE_SORTED.length === 3 ? '三' : '五'}种格式可选；
记住，所有判断题的题目不要包含参考文档的名称，语句都必须为陈述句，以中文句号"。"结尾；

##输出的参考格式示例
${currentQuesType}${LEVEL_TYPE[0]}原子性不是面向对象三大特征之一。 
${ANSWER_TEXT_KEY}：${ANSWER_TYPE[1]}
${EXPLAIN_TEXT_KEY}：原子性不是面向对象的特性。`,

    // 填空题示例
    `
##输出的格式要求
"${LEVEL_TYPE[1]}"标识试题的难易度；
"${ANSWER_TEXT_KEY}"标识试题的答案；
"${EXPLAIN_TEXT_KEY}"标识试题的解析；
"${currentQuesType}"标识试题的题型；
"(  )"标识正确答案填空的位置；
每道试题的第一行是试题的题干；
题型写在试题题干的最前面，难易度跟在题型后面；
题型、难易度、题干、"(  )"在同一行上面；
答案写在题干的下面一行，解析写在答案的下面一行；
每道填空题的题干上面用"(  )"表示正确答案需要填空的位置；
"(  )"里面不要填充内容；
每道试题的难度仅有：${LEVEL_TYPE_SORTED.join('、')} ${LEVEL_TYPE_SORTED.length === 3 ? '三' : '五'}种格式可选；
请保证每道题均来自于知识内容；
请不要输出分析过程内容，直接按照格式示例输出内容；
不要输输出JSON格式；

##输出的参考格式示例
${currentQuesType}${LEVEL_TYPE[1]}面向对象的特征有(  ),(  ),(  )。
${ANSWER_TEXT_KEY}：封装性；继承性；多态性
${EXPLAIN_TEXT_KEY}：面向对象特性有封装性、继承性、多态性。`,

    // 问答题题示例
    `
##输出的格式要求
"${LEVEL_TYPE[2]}"标识试题的难易度；
"${ANSWER_TEXT_KEY}"标识试题的答案；
"${EXPLAIN_TEXT_KEY}"标识试题的解析；
"${currentQuesType}"标识试题的题型；
每道试题的第一行是试题的题干；
题型写在试题题干的最前面，难易度跟在题型后面；
题型、难易度、题干在同一行上面；
答案写在题干的下面一行，解析写在答案的下面一行；
每道试题的难度仅有：${LEVEL_TYPE_SORTED.join('、')} ${LEVEL_TYPE_SORTED.length === 3 ? '三' : '五'}种格式可选；
请保证每道题均来自于知识；
请不要输出分析过程内容，直接按照格式示例输出内容；
每道试题的题干不要太长；
不要输出JSON格式；

##输出的参考格式示例
${currentQuesType}${LEVEL_TYPE[2]}面向对象的特征包括哪些？
${ANSWER_TEXT_KEY}：封装性、继承性、多态性
${EXPLAIN_TEXT_KEY}：面向对象特性有封装性、继承性、多态性。`

  ];

  return caseAll[createQuesType];
};

/**
 * 解析对话内容中AI输出的试题
 * @param {String} inputTxt 试题文本
 * @param {String} preCheck 预校验不完整的文本
 * @param {String} force 强制转换试题
 * @returns 文本初步转化的试题列表
 */
export const analysisInputText = function(inputTxt, preCheck, force) {
  const keywords = getAIQuesPromptKeywords();
  const QUES_TYPE = keywords.quesType;
  const ANSWER_TYPE = keywords.judgeAnswer;
  // 解析
  const EXPLAIN_TEXT_KEY = bracketKey[0] + keywords.explain + bracketKey[1];

  let quesTexts = inputTxt;

  // 完整的输出 需要格式化下
  if (!preCheck) {
    let tmpValue = quesTexts + '\r\n';
    tmpValue = tmpValue
      .replace(/[\n]([\n])+/g, '\n\n')
      .replace(/[\r]([\r])+/g, '\r\r')
      .replace(/[\r][\n]([\r][\n])+/g, '\r\n\r\n');
    // 试题信息
    quesTexts = tmpValue;
  }

  // 读取每行试题信息
  const textLine = quesTexts.split('\n');

  const questions = [];
  let findQ = false; // 是否找到试题
  let endQ = false; // 单题结束
  let quesExplain = ''; // 有解析
  let preEmpty = false; // 前一行为空行
  let optionTag = 0; // 选项前的a.b.c.d ai不可控，有时候会加有时候不会。 0：为标准选项不带这些，1：带 abcd, -1：带 abcd但是当前行却没有可能是解析
  let startTxt = ''; // 起始引导语

  // 匹配常见的答案解析
  const patternAnswer = new RegExp(`^${i18n.t('pc_biz_ote_lbl_itemanswer')}[：:]\\s*`, 'i');
  const patternAnswerList = new RegExp(`^${i18n.t('pc_biz_ote_lbl_itemanswer')}[：:]\\s*[A-Za-z、,\\s]+`, 'i');
  // const patternFillinAnser = /[、；;，,|]/;
  const patternFillinAnser = /[；;|]/;
  const patternExplain = new RegExp(`^${i18n.t('pc_biz_ote_lbl_quesanalyze')}[：:]\\s*`, 'i');
  const patternJudgeY = new RegExp('^A[\\w\\W]+\\[Y\\]$', 'i');
  const patternJudgeN = new RegExp('^B[\\w\\W]+\\[N\\]$', 'i');
  const patternJudgeTitleEnd = new RegExp('\\[Y/N\\]$', 'i');
  const patternJudgeTitleEndBr = new RegExp('\\[Y/N\\]\\r\\n$', 'i');
  const patternJudgeCorrectKW = ['A', 'Y', bracketKey[0] + 'Y' + bracketKey[1], ANSWER_TYPE[1], i18n.t('pc_biz_ote_lbl_wright'), i18n.t('pc_biz_ote_lbl_yes'), i18n.t('pc_biz_ote_lbl_yes2') ];

  // 初始化当前检查试题的信息
  let currentQ = resetCurrentQ();
  for (let row = 0; row < textLine.length; row++) {
    const line = trim(textLine[row]);

    // 获取题型，有题型标记代表当前题目开始及上一题结束了
    let quesTypeLine = getQType(line, preEmpty);
    let quesTypeLineForce = '';
    // 非空行，但是没有找到题型的时候，设置为默认题型
    if (!isEmpty(line) && !quesTypeLine && force && !(currentQ && currentQ.type)) {
      quesTypeLine = getQType(line, preEmpty, true);
      quesTypeLineForce = quesTypeLine;
    }

    if (isEmpty(line)) {
      if (textLine.length - 1 === row) {
        endQ = true;// 最后行了
      } else if (currentQ && currentQ._type) {
        endQ = true;// 没写题型的空行认为结束了
      } else {
        preEmpty = true; // 标记当前为空行，用于下一行处理
        continue;
      }
    }
    preEmpty = false;

    if (quesTypeLine || endQ) {
      // forced = true;
      if (findQ) {
        questions.push(currentQ);
      } else if (!isEmpty(currentQ.title) && questions.length === 0) {
        startTxt += currentQ.title;
      }
      optionTag = 0;
      quesExplain = '';
      // 重置当前新的试题信息
      currentQ = resetCurrentQ();
      findQ = false;
      if (endQ) {
        endQ = false;
        continue;
      };
    }

    currentQ.originTxt += line + '\r\n';
    currentQ._originTxt += line + '\r\n';

    if (!findQ) {
      if (!isEmpty(currentQ.title)) {
        // 当前试题题目补位空，加换行符
        currentQ.title += '\r\n';
      }
      // 设置标题
      currentQ.title += line;
      // 设置标题行号
      currentQ.titleLine = row + 1;
      // 获取试题难易度
      currentQ.levelType = getLevel(line);
      // 获取试题类型
      currentQ.type = quesTypeLine;
      currentQ._type = quesTypeLineForce;

      // 判断是否是题目标题行
      if (!isEmpty(currentQ.type)) {
        currentQ.title = currentQ.title
          .replace(currentQ.type, '')
          .replace(currentQ.levelType, '');
        // 找到试题
        findQ = true;
        // 判断题只有一行标题行，类型不为空，则进行判断
        if (currentQ.type === QUES_TYPE[2]) {
          currentQ._originTxt = currentQ._originTxt.replace(patternJudgeTitleEndBr, '\r\n');

          // 判断题设置标题
          currentQ.title = currentQ.title
            .replace(ANSWER_TYPE[1], '')
            .replace(ANSWER_TYPE[0], '')
            .replace(patternJudgeTitleEnd, '');
          currentQ.yesno = false;
          currentQ.key = '';
          if (line.indexOf(ANSWER_TYPE[1]) !== -1 || line.indexOf(ANSWER_TYPE[0]) !== -1) {
            // 设置题目标题
            currentQ.key = line;
            // 设置正误
            currentQ.yesno = isKey(line);
          }
        }
      }
    } else {
      // 选择题单独一行标记正确答案。  答案：A、B...   这种形式。
      if ((currentQ.type === QUES_TYPE[0] || currentQ.type === QUES_TYPE[1]) &&
            patternAnswerList.test(line)
      ) {
        let answerText = line.replace(patternAnswer, '');
        currentQ.options.forEach((option, index) => {
          const optionKey = convertASCIIForNum(index);
          if (optionKey && answerText.indexOf(optionKey) >= 0) {
            option.yesno = true;
          }
        });

        // 兼容没有写题型的情况
        if (currentQ._type === QUES_TYPE[0]) {
          if (!currentQ.options || currentQ.options.length === 0) {
            // 无选项默认为简答题
            currentQ.type = QUES_TYPE[4];
            currentQ.key += answerText;
          } else if (currentQ.options.filter(o => o.yesno).length > 1) {
            // 答案不止一个为多选题
            currentQ.type = QUES_TYPE[1];
          }
        }
        continue;
      }

      // 处理解析。默认最后行为解析，可以不加标注
      let explainText =
            line &&
            line.indexOf(EXPLAIN_TEXT_KEY) >= 0 &&
            line.replace(EXPLAIN_TEXT_KEY, '');
      // 解析多行累计
      if (quesExplain) {
        explainText = quesExplain + '\r\n' + line;
      }
      // 兼容  "解析："
      if (!explainText && line && patternExplain.test(line)) {
        explainText = line.replace(patternExplain, '');
      }
      // 兼容 兼容选项ABCD结束后即使没标记也判定为解析
      if (
        !explainText &&
            optionTag === 1 &&
            replaceOptionPrefix(line, currentQ.options.length) === line
      ) {
        explainText = line;
      }
      if (explainText) {
        currentQ.explainText = explainText;
        quesExplain = explainText;

        // 填空题未设置答案时直接使用解析
        if (currentQ.type === QUES_TYPE[3] && currentQ.options.length === 0) {
          // 设置填空题答案
          currentQ.options = [{
            option: explainText,
            yesno: true
          }];
        }
        continue;
      }

      // 处理选项及选项后的答案
      if (currentQ.type === QUES_TYPE[0] || currentQ.type === QUES_TYPE[1]) {
        // 单选题、多选题 （读取的行选项信息存入到currentQ.options）[Y、N]标记在选项后的答案在此处理
        const option = line
          .replace(ANSWER_TYPE[1], '')
          .replace(ANSWER_TYPE[0], '');
        optionTag =
              replaceOptionPrefix(option, currentQ.options.length) ===
              option
                ? 0
                : 1;
        currentQ.options.push({
          option: option,
          yesno: isKey(line)
        });
        // 去掉给用户看的选项上的[Y]标记，避免产生误解
        currentQ._originTxt = currentQ._originTxt.replace(line, option);
      } else if (currentQ.type === QUES_TYPE[2]) {
        // 判断题非题干上的答案输出处理
        if (patternAnswer.test(line) && !currentQ.key) {
          const as = line.replace(patternAnswer, '').trim();
          // A Y [Y] 正确 是 对
          currentQ.yesno = patternJudgeCorrectKW.includes(as);
          currentQ.key = currentQ.title;
        }
        if (patternJudgeY.test(line) || patternJudgeN.test(line)) {
          currentQ.yesno = patternJudgeN.test(line);
          currentQ.key = currentQ.title;
        }
      } else if (currentQ.type === QUES_TYPE[3]) {
        // 设置填空题答案
        if (patternAnswer.test(line)) {
          const fillinAnswer = line.replace(patternAnswer, '').split(patternFillinAnser);
          fillinAnswer.forEach((as) => {
            as && currentQ.options.push({
              option: as,
              yesno: true
            });
          });
        } else {
          currentQ.options.push({
            option: line.replace(patternAnswer, ''),
            yesno: true
          });
        }
      } else if (currentQ.type === QUES_TYPE[4]) {
        // 设置问答题答案
        currentQ.key += (currentQ.key ? '\n' : '') + line.replace(patternAnswer, '');
      }
    }
  }

  return {
    inputTxt: quesTexts, // 格式化后的文本
    startTxt, // 解析出的 试题前AI说的引导语
    questions // 解析出的 试题
  };
};
/**
 * 页面输入的试题文本解析出的题目信息
 * @param {Array} questions 文本初步转化的试题列表
 * @param {*} libId 题库ID
 * @param {*} libName 题库名称
 * @returns 转化后的试题结构
 */
export const getAnalysedQuesList = function(questions, libId, libName) {
  const keywords = getAIQuesPromptKeywords();
  const QUES_TYPE = keywords.quesType;
  const LEVEL_TYPE = keywords.levelType;
  const quesList = [];
  let qType = 0; // 试题类型
  let lType = 0; // 难易度
  let q = null;
  for (let i = 0; i < questions.length; i++) {
    q = questions[i];
    qType = QUES_TYPE.indexOf(q.type);
    if (q.levelType !== '') {
      lType = LEVEL_TYPE.indexOf(q.levelType);
    }
    // 设置question默认值
    const question = {
      answerContent: '',
      content: '',
      examId: '',
      explainText: '',
      judgeAnswer: 0,
      keywords: [],
      levelType: 0,
      noOrderMark: 0,
      pointIds: [],
      questionItems: [],
      score: 0,
      status: 0,
      summary: '',
      quesType: 0, // 题目的音视频类型
      type: 0, // 题型
      addBackup: 0,
      syncToExam: 0
    };
    // 各类型通用基本信息赋值
    question.type = qType;
    question.levelType = lType;
    question.content = htmlEncodeAndAddP(
      replaceTitlePrefix(q.title)
    );
    question.summary = replaceTitlePrefix(q.title);
    question.explainText = htmlEncodeAndAddP(q.explainText);

    question.libId = libId || '';
    question.libName = libName || '';

    checkQ(q);
    question.origin = q;
    if (q.error) {
      question.error = q.error;
      question.errorMsg = q.errorMsg;
    }

    switch (qType) {
      // 单选题、多选题、填空题
      case 0:
      case 1:
      case 3:
        for (let k = 0; k < q.options.length; k++) {
          question.questionItems.push({
            alternativeContents: [],
            answer: q.options[k].yesno ? 1 : 0,
            id: getGuid(),
            itemContent:
                  qType === 3
                    ? q.options[k].option
                    : htmlEncodeAndAddP(
                      replaceOptionPrefix(q.options[k].option, k)
                    )
          });
        }
        question.answer = question.questionItems
          .filter(item => item.answer)
          .map(item => item.id);
        question.itemAnswerObj = question.questionItems.map(item => ({
          itemAnswer: item.itemContent
        }));
        break;
        // 判断题
      case 2:
        question.judgeAnswer = q.key ? (q.yesno ? 1 : 0) : -1;
        break;
        // 问答题
      case 4:
        question.answerContent = htmlEncodeAndAddP(q.key);
        break;
    }

    quesList.push(question);
  }

  return quesList;
};

// 检查试题的合法性
const checkQ = function(ques) {
  const keywords = getAIQuesPromptKeywords();
  const QUES_TYPE = keywords.quesType;
  ques.error = 1; // 1.题目  2.选项  3.答案 错误在哪

  if (isEmpty(ques.title)) {
    setErrorMsg(ques, i18n.t('pc_biz_ote_msg_nosetqcontent'), 1); // 未设置试题内容
    return;
  }

  // 单选题、判断题 检查是否有选项
  if (ques.type === QUES_TYPE[0] || ques.type === QUES_TYPE[1]) {
    // 获取选项总个数和正确项个数
    const keys = getKeyCount(ques);
    // 未设置选项提示
    if (keys.all === 0) {
      setErrorMsg(ques, i18n.t('pc_biz_ote_msg_nosetqoption'), 1); // 未设置选项
      return;
    }
    // 单选多选必须大于1
    if (keys.all === 1) {
      setErrorMsg(
        ques,
        ques.type === QUES_TYPE[0]
          ? i18n.t('pc_biz_ote_msg_singlechoice2least')
          : i18n.t('pc_biz_ote_msg_multchoice2least'),
        1
      ); // 单选题至少2个选项 多选题至少2个选项
      return;
    }
    // 单选、多选选项不能超过12个
    if (keys.all > 12) {
      setErrorMsg(
        ques,
        ques.type === QUES_TYPE[0]
          ? i18n.t('pc_biz_ote_msg_singlechoice12exceed')
          : i18n.t('pc_biz_ote_msg_multchoice12exceed'),
        1
      ); // 单选题不能超过12个选项 多选题不能超过12个选项
      return;
    }
    if (keys.yes === 0) {
      setErrorMsg(ques, i18n.t('pc_biz_ote_msg_nosetcorrentitem'), 2); // 未设置正确项
      return;
    }
    // 单选题检查正确项个数
    if (ques.type === QUES_TYPE[0]) {
      if (keys.yes > 1) {
        setErrorMsg(
          ques,
          i18n.t('pc_biz_ote_msg_singlechoice1more'),
          2
        ); // 单选题超过1个正确项
        return;
      }
    }
    // 多选题检查正确答案项个数
    if (ques.type === QUES_TYPE[1]) {
      if (keys.yes < 1) {
        setErrorMsg(
          ques,
          i18n.t('pc_biz_ote_msg_multchoice1more'),
          2
        ); // 多选题至少1个正确项
        return;
      }
    }
  } else if (
    ques.type === QUES_TYPE[3] ||
        ques.type === QUES_TYPE[4]
  ) {
    // 填空题看是否设置答案
    if (ques.type === QUES_TYPE[3]) {
      if (ques.options.length === 0) {
        setErrorMsg(ques, i18n.t('pc_biz_ote_msg_nosetanswer'), 2); // 未设置答案
        return;
      }
      // 答案不能超过12个
      if (ques.options.length > 12) {
        setErrorMsg(
          ques,
          i18n.t('pc_biz_ote_msg_fillinanswer12exceed'),
          1
        ); // 填空题不能超过12个答案
        return;
      }
      for (let i = 0; i < ques.options.length; i++) {
        if (ques.options[i].length > 200) {
          setErrorMsg(
            ques,
            i18n.t('pc_biz_ote_msg_fillanswerexceed', [200]),
            2
          ); // 填空题答案项的长度不能超过200
          return;
        }
      }
    }
  } else if (ques.type === QUES_TYPE[2]) {
    // 判断题是否设置答案
    if (isEmpty(ques.key)) {
      setErrorMsg(ques, i18n.t('pc_biz_ote_msg_nosetanswer'), 2); // 未设置答案
      return;
    }
  }

  ques.error = 0;
};
// 设置错误提示信息
const setErrorMsg = function(ques, msg, type) {
  ques.error = type;
  ques.errorMsg = msg;
};
// 重置题目
const resetCurrentQ = function() {
  return {
    title: '',
    titlePos: 0,
    titleLine: 0,
    type: '',
    _type: '',
    options: [],
    yesno: false,
    key: '',
    explainText: '',
    originTxt: '',
    _originTxt: '',
    error: 0
  };
};
// 获取试题类型
const getQType = function(txt, preEmpty, force) {
  const keywords = getAIQuesPromptKeywords();
  const QUES_TYPE = keywords.quesType;
  for (const i in QUES_TYPE) {
    if (txt.indexOf(QUES_TYPE[i]) !== -1) {
      return QUES_TYPE[i];
    }
  }
  if (getLevel(txt) && preEmpty) {
    return QUES_TYPE[0];
  }
  if (force) {
    return QUES_TYPE[0];
  }
  // 问答题、简答题 兼容
  if (txt.indexOf(i18n.t('pc_biz_ote_lbl_questype4-2')) !== -1) {
    return QUES_TYPE[4];
  }

  return '';
};
// 获取试题难易度
const getLevel = function(txt) {
  const keywords = getAIQuesPromptKeywords();
  const LEVEL_TYPE = keywords.levelType;
  for (const i in LEVEL_TYPE) {
    if (txt.indexOf(LEVEL_TYPE[i]) !== -1) {
      return LEVEL_TYPE[i];
    }
  }
  return '';
};
// 判断是否包含正确答案
const isKey = function(a) {
  // 试题答案类型
  return a.indexOf(bracketKey[0] + 'Y' + bracketKey[1]) !== -1;
};
// 获取选项总个数和正确项个数
const getKeyCount = function(ques) {
  const keys = { all: 0, yes: 0 };
  for (let index = 0; index < ques.options.length; index++) {
    if (ques.options[index].yesno) {
      keys.yes++;
    }
    keys.all++;
  }
  return keys;
};
// 清除空格
const trim = function(a) {
  if (a && a.replace) {
    return a.replace(/(^\s*)|(\s*$)/g, '');
  } else {
    return a;
  }
};
// 判断是否为空
const isEmpty = function(a) {
  return trim(a) === '';
};
// 替换掉选项前的a/b/c/d
const replaceOptionPrefix = function(option, index) {
  if (index !== undefined) {
    // 选项序号严格匹配对应的abcd
    const patternOption = new RegExp(
      `^\\s*[${convertASCIIForNum(index)}${convertASCIIForNum(
        index,
        true
      )}][\\.、]\\s*`,
      'i'
    );
    return option.replace(patternOption, '');
  }
  return option.replace(/^\s*[A-Za-z][\.、]\s*/, '');
};
// 替换掉题目前的1234等序号类前缀
export const replaceTitlePrefix = function(title) {
  // 1. XXXXXX     题目2：XXXXXXX
  return title.replace(/^(\s*[0-9]{1,2}\.\s*)|(\s*((题目)|(试题))[0-9]{1,2}[:：]\s*)*/, '');
  // return title.replace(/^\s*[0-9]{1,2}\.\s*/, '');
};
// 富文本内容补充P标签，对齐富文本的正常样式
const htmlEncodeAndAddP = function(txt) {
  const txtEncoded = htmlEncode(txt);
  // 带html符号被编码时，包裹p标签，对齐富文本
  return txtEncoded !== txt ? `<p>${txtEncoded}</p>` : txtEncoded;
};
